export function getSelectedText() {
  let text = "";
  if (window.getSelection) {
    text = window.getSelection().toString();
  }

  if (!text && document.selection && document.selection.type != "Control") {
    text = document.selection.createRange().text;
  }
  return text;
}
